import { combineReducers } from 'redux';

const isActive = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_NOTIFICATIONS_SUCCESS': {
      const isRemindersSet = action.resp.tnhcUserReminders === 'true';
      return isRemindersSet;
    }
    case 'SEND_NOTIFICATIONS_SUCCESS':
      return action.resp;
    default:
      return state;
  }
};

const reminderHasUpdated = (state = false, action) => {
  switch (action.type) {
    case 'SEND_NOTIFICATIONS_SUCCESS':
      return true;
    case 'FETCH_NOTIFICATIONS_FAILURE':
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isActive,
  reminderHasUpdated,
});
